import './footer.css'
import React from 'react'

export default function Footer() {
	return (
					<footer className="footer mt-4 bg-success py-3 ">
			  <div className="container">
			    <p className=" footer-text">Utkarsh Dixit &copy; 2022 ...</p>
			  </div>
			</footer>
	)
}